import { Component, OnInit } from '@angular/core';
import { DataService } from '../shared/dataservice.service';
@Component({
  selector: 'app-brain-storm',
  templateUrl: './brain-storm.component.html',
  styleUrls: ['./brain-storm.component.css']
})
export class BrainStormComponent implements OnInit {

  constructor(public _dataService:DataService) { }

  ngOnInit() {
    this._dataService.currPageName = "Brainstorm";
  }

}
